import React, { Component } from 'react';
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { PootsyButton } from "../DesignFunctions"
import * as actions from "../../actions/acBookingFlow"

import { PootsyTextInput } from "../InputsFunctions"
import ModalLayout from "../shared/ModalLayout"

class ZipCodeNotCoveredModal extends Component {
	render() {

		let { t } = this.context

		let email = this.props.metadata.emailZipCodeNotCovered

		let title = this.props.title === undefined ? t('enter_zip_code_not_covered_modal_title') : this.props.title
		let description = this.props.description === undefined ? t('enter_zip_code_not_covered_modal_description') : this.props.description

		return (
			<ModalLayout
				customClass="EnterZipCodeNotCovered"
				contentClass="enter-zipcode-not-covered-modal-content"
				title={title}
				closeModal={this.toggleModal}
				buttons={[
					<PootsyButton text={t("send")} onClick={this.sendEmail} key={0} disabled={email === ''}/>,
					<PootsyButton text={t("cancel")} theme="cancel" onClick={this.toggleModal} key={1}/>
				]}
			>
				<div>
					<div className="description">{description}</div>
					<PootsyTextInput placeholder={t('email_input_placeholder')}
									 name="email"
									 label={t('email_input_label')}
									 value={email}
									 onChange={this.emailChanged}
					/>
				</div>
			</ModalLayout>
		)
	}

	toggleModal = () => {
		this.props.dispatch(actions.bookingFlowMetaChange({enterZipCodeNotCovered: false }))
	}

	sendEmail = () => {
		this.props.dispatch(actions.askForZipCode())
	}

	emailChanged = e => {
		this.props.dispatch(actions.bookingFlowMetaChange({emailZipCodeNotCovered: e.target.value}))
	}

}

ZipCodeNotCoveredModal.contextTypes = { t: PropTypes.func }
const mapStateToProps = state => ({
	metadata: state.metadataReducer.bookingFlow
})
export default connect(mapStateToProps)(ZipCodeNotCoveredModal);



// WEBPACK FOOTER //
// ./src/components/bookingflow/ZipCodeNotCoveredModal.js